import { authenticateRequest } from '@api/authenticateRequest';

import type { operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type GetPushesQuery =
  operations['AdminNotificationController_getNotificationList']['parameters']['query'];
type GetPushesHeaders =
  operations['AdminNotificationController_getNotificationList']['parameters']['header'];

interface GetPushesProps {
  query: GetPushesQuery;
  headers?: OmitGroupIdInHeader<GetPushesHeaders>;
}

type GetPushesResponse = { rows: Push[]; count: number };

export async function getPushes({
  query,
  headers,
}: GetPushesProps): Promise<GetPushesResponse | false> {
  const response = await authenticateRequest<GetPushesResponse>({
    method: 'get',
    url: `/api/v1/admin/notifications`,
    headers,
    params: query,
  });

  return response;
}

export type { GetPushesQuery, GetPushesResponse };

export interface Push {
  notification: {
    payload: null;
    targetIds: [4];
    id: 49;
    createdAt: '2023-04-20T02:23:59.808Z';
    updatedAt: '2023-04-20T02:24:00.507Z';
    deletedAt: null;
    groupId: 2;
    categoryId: 1;
    link: '/familyEvent/request/1';
    title: '경조사 등록 신청이 접수되었습니다.';
    subtitle: null;
    message: '등록 신청이 승인되면 알림이 가며, 경조사 리스트에 추가됩니다.';
    sendStatus: 'completed';
    sendAt: null;
    targetType: 'member';
    category: {
      id: 1;
      createdAt: '2023-02-10T04:10:45.899Z';
      updatedAt: '2023-02-10T04:10:45.899Z';
      deletedAt: null;
      groupId: 2;
      name: 'event';
      default: true;
      type: 'system';
      unused: false;
    };
  };
  errorCount: number;
  pendingCount: number;
  rejectCount: number;
  successCount: number;
}
